<div class="stripe-card-container">
  <div class="input">
    <label class="required" i18n="@@payment_method.label.creditcard_number">
      Kreditkarten-Nummer
    </label>
    <div
      id="stripe-card-number-{{ uniqueInstanceId }}"
      class="form-control ng-dirty ng-touched"
      [ngStyle]="{ 'background-color': styles.inputFieldColor }"
      [class.ng-invalid]="stripeError$['number'] | async"
    >
    </div>
    <div
      class="error-container"
      *ngIf="stripeError$['number'] | async as error"
    >
      {{ error }}
    </div>
  </div>

  <div class="d-flex">
    <div class="input">
      <label class="required" i18n="@@payment_method.label.valid_to">
        Gültig bis
      </label>
      <div
        id="stripe-card-expire-{{ uniqueInstanceId }}"
        class="form-control ng-dirty ng-touched"
        [ngStyle]="{ 'background-color': styles.inputFieldColor }"
        [class.ng-invalid]="stripeError$['expire'] | async"
      >
      </div>
      <div
        class="error-container"
        *ngIf="stripeError$['expire'] | async as error"
      >
        {{ error }}
      </div>
    </div>

    <div class="input" id="creditcard_securitycode">
      <div class="label-container">
        <label i18n="@@payment_method.label.cvv" class="required">CVV </label>
        <a
          id="creditcard_securitycode_help"
          href="#"
          tabindex="-1"
          i18n="
            Es geht um die
            Kreditkartenprüfnummer@@lpayment_method.label.cvv_whats_this"
          (click)="$event.preventDefault(); cvcDialog.open()"
          >Was ist CVV?</a
        >
      </div>
      <div
        id="stripe-card-cvc-{{ uniqueInstanceId }}"
        class="form-control ng-dirty ng-touched"
        [ngStyle]="{ 'background-color': styles.inputFieldColor }"
        [class.ng-invalid]="stripeError$['cvc'] | async"
      >
      </div>
      <div class="error-container" *ngIf="stripeError$['cvc'] | async as error">
        {{ error }}
      </div>
    </div>
  </div>
</div>

<orderform-cvc-dialog #cvcDialog></orderform-cvc-dialog>
